import { render, staticRenderFns } from "./show-passport-data.vue?vue&type=template&id=0fef3eb2&scoped=true&"
import script from "./show-passport-data.vue?vue&type=script&lang=js&"
export * from "./show-passport-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fef3eb2",
  null
  
)

export default component.exports